export default __webpack_public_path__ + "static/media/landing-page-bg.b2d8ceac.png";